import React from 'react';
import { PlaidEmbeddedLink } from 'react-plaid-link';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { useConfig } from 'config/ConfigContext';
import { exitPlaid } from 'actions/plaid';

import withPlaidSessionId from './WithPlaidSession';

const Plaid = ({
  linkToken,
  sessionId,
  onPlaidSuccess,
  onPlaidExit,
}) => {
  const dispatch = useDispatch();
  const { apiUrl } = useConfig();

  const onSuccess = (publicToken, metadata) => {
    onPlaidSuccess(publicToken, metadata, sessionId);
  };

  const onExit = (err, metadata) => {
    dispatch(exitPlaid({
      data: {
        error: err,
        institution: metadata?.institution,
        linkSessionId: metadata?.link_session_id,
        requestId: metadata?.request_id,
        status: metadata?.status,
      },
      apiUrl: `${apiUrl}/plaid/session/${sessionId}/exit`,
    }));
    onPlaidExit();
  };

  const onEvent = (eventName, metadata) => {
    console.log('Plaid event:', eventName, metadata);
  };

  return (
    <div style={{ minHeight: '400px', width: '100%' }}>
      {linkToken && <PlaidEmbeddedLink
        token={linkToken}
        onSuccess={onSuccess}
        onExit={onExit}
        onEvent={onEvent}
        style={{ width: '100%', height: '400px' }}
      />}
    </div>
  );
};

Plaid.propTypes = {
  sessionId: PropTypes.string.isRequired,
  linkToken: PropTypes.string.isRequired,
  onPlaidSuccess: PropTypes.func.isRequired,
  onPlaidExit: PropTypes.func.isRequired,
};

export default withPlaidSessionId(Plaid);
